import { render, staticRenderFns } from "./BmlrEdit.vue?vue&type=template&id=09e5ddaa"
import script from "./BmlrEdit.vue?vue&type=script&lang=js"
export * from "./BmlrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports